<template>
    <div :class="!fromEmployeeDetails?'content-wrapper':''">
        <app-page-top-section v-if="!fromEmployeeDetails" :title="$t('summery')">
            <div class="d-flex d-inline">
                <app-attendance-top-buttons
                    :specific-id="specificId"
                    :tableId="tableId"
                    :setting-button="false"
                />

                <div v-if="$can('import_employees') || $can('export_attendance_summery') || (exportable && $can('export_all_attendance_summery'))"
                     class="btn-group dropdown ml-2">
                    <button class="btn btn-primary rounded-right px-3" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        {{ $t('actions') }} <i class="fas fa-chevron-down fa-sm"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a v-if="exportable && $can('export_all_attendance_summery')" class="dropdown-item" href="#"
                           @click.prevent="viewExportAllModal">
                            <app-icon name="download" class="size-16 mr-1"/>
                            {{ $t('export_all') }}
                        </a>
                        <a v-if="$can('export_attendance_summery')" class="dropdown-item" href="#"
                           @click.prevent="viewConfirmationModal()">
                            <app-icon name="download" class="size-16 mr-1"/>
                            {{ $t('export') }}
                        </a>
                        <a v-if="$can('import_employees')" class="dropdown-item" href="#"
                           @click.prevent="isImportModalActive = true">
                            <app-icon name="upload" class="size-16 mr-1"/>
                            {{ $t('import') }}
                        </a>
                    </div>
                </div>
            </div>
        </app-page-top-section>

        <app-filter-with-search
            :key="'attendance-summary-filter-' + filterStateVersion"
            :options="filteredTableOptions"
            @filteredValue="setUserId"
            v-if="!specificEmployee"
        />

        <div :class="fromEmployeeDetails?'': 'card card-with-shadow border-0'" style="min-height: 400px;">

            <div
                :class="!fromEmployeeDetails?'p-primary':'px-0 pt-0 pb-primary'"
                class="card-header d-flex align-items-center justify-content-between primary-card-color">
                <app-month-calendar/>
                <app-period-calendar
                    :key="'attendance-period-calendar-' + filterStateVersion"
                    :initial-filter-value="filterQuery.within"
                />
            </div>

            <app-overlay-loader v-if="preloader"/>

            <div :class="!fromEmployeeDetails?'p-primary':'p-0'" class="card-body" v-else>
                <div class="d-flex justify-content-between" v-if="!specificEmployee">
                    <div class="media align-items-center">
                        <app-avatar
                            :title="employee.full_name"
                            avatar-class="avatars-w-50"
                            :status="$optional(employee, 'status', 'class')"
                            :img="$optional(employee, 'profile_picture', 'full_url')"
                        />

                        <div class="media-body ml-3">
                            <a :href="profileUrl">{{ employee.full_name }}</a>
                            <p class="text-muted font-size-90 mb-0">
                                {{ employee.department.name }}, {{employee.profile.employee_id}}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <a href="#" @click="changeUser('previous')" :class="{'disabled text-muted' : isPreviousNull}">
                            {{ $t('previous') }}
                        </a>
                        <span class="text-muted px-2">|</span>
                        <a href="#" @click="changeUser('next')" :class="{'disabled text-muted' : isNextNull}">
                            {{ $t('next') }}
                        </a>
                    </div>
                </div>

                <employee-attendance-summary
                    :summaries="summaries"
                    :data="dataSet"
                />

                <app-attendance-summary-table
                    :specific-employee="fromEmployeeDetails"
                    :details-id="detailsId"
                    :attendance-id="attendanceId"
                    :user="employee"
                    @checkTableData="setTableDataNumber"
                />

            </div>
        </div>

        <app-confirmation-modal
            v-if="exportConfirmationModal"
            :title="modalSubtitle"
            :message="modalMessage"
            modal-id="app-confirmation-modal"
            modal-class="primary"
            icon="download"
            :first-button-name="$t('export')"
            :second-button-name="$t('cancel')"
            @confirmed="exportFilteredAttendance()"
            @cancelled="exportConfirmationModal = false"
            :self-close="false"
        >
            <template #body>
                <div class="m-3 text-center text-size-18">
                    <label class="radio-inline mr-4 cursor-pointer">
                        <input type="radio" :value="'simple'" v-model="exportType" />
                        {{ $t('simple') }}
                    </label>
                    <label class="radio-inline cursor-pointer">
                        <input type="radio" :value="'advance'" v-model="exportType" />
                        {{ $t('advance') }}
                    </label>
                </div>
            </template>
        </app-confirmation-modal>

        <app-confirmation-modal
            v-if="noDataFoundModal"
            :message="this.$t('please_filter_the_attendance_data_first')"
            :title="this.$t('no_attendance_data_found')"
            :second-button-name="$t('okay')"
            :hide-first-button="true"
            modal-class="warning"
            icon="filter"
            modal-id="app-confirmation-modal"
            @cancelled="noDataFoundModal = false"
            :self-close="false"
        />

        <export-all-attendance-modal
            :show-modal="exportAllModal"
            :time-range="filterQuery.time_range"
            :filter-state="filterQuery"
            @close-modal="closeExportAllModal"
            @confirm-export="handleConfirmExport"
        />

        <attendance-import-modal
            v-if="isImportModalActive"
            v-model="isImportModalActive"
            @import-complete="handleImportComplete"
        />
    </div>
</template>

<script>
import AppAttendanceTopButtons from "./Component/AppAttendanceTopButtons";
import MemoizeMixins from "../../../../common/Helper/Support/MemoizeMixins";
import AttendanceHelperMixin from "../../Mixins/AttendanceHelperMixin";
import AttendanceSummaryDetailsMixin from "../../Mixins/AttendanceSummaryDetailsMixin";
import {DepartmentFilterMixin} from '../../Mixins/FilterMixin';
import EmployeeAttendanceSummary from "./Component/EmployeeAttendanceSummary";
import ExportAllAttendanceModal from "./Component/ExportAllAttendanceModal";
import AttendanceImportModal from "./AttendanceImportModal";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {collection} from "../../../../common/Helper/helpers";
import {localTimeZone} from "../../../../common/Helper/Support/DateTimeHelper";
import moment from 'moment';
import {objectToQueryString} from "../../../../common/Helper/Support/TextHelper";

export default {
    name: "AttendanceSummery",
    components: {
        EmployeeAttendanceSummary,
        AppAttendanceTopButtons,
        ExportAllAttendanceModal,
        AttendanceImportModal
    },
    created() {
        this.hydrateFromUrl();
    },
    props: {
        detailsId: {},
        attendanceId: {},
        firstUser: {
            default: function () {
                return {}
            }
        },
        specific: {},
        fromEmployeeDetails: {}
    },
    mixins: [
        MemoizeMixins,
        AttendanceHelperMixin,
        AttendanceSummaryDetailsMixin,
        DepartmentFilterMixin,
    ],
    data() {
        return {
            tableId: 'summary',
            preloader: true,
            summaries: {},
            dataSet: [],
            isChanging: false,
            nextUser: {},
            filterLoaded: true,
            exportConfirmationModal: false,
            noDataFoundModal: false,
            exportAllModal: false,
            isImportModalActive: false,
            tableData: 0,
            modalMessage: '',
            modalSubtitle: '',
            exportAllEmployee: false,
            exportType: 'simple',
            selectedUserId: null,
            filterStateVersion: 0,
            historySyncMode: 'replace',
        }
    },
    methods: {
        parseQueryValue(rawValue) {
            if ([null, undefined, ''].includes(rawValue)) {
                return null;
            }

            try {
                return JSON.parse(rawValue);
            } catch (e) {
                return rawValue;
            }
        },
        applyFilterActiveState(filterKey, value, targetFilters = this.options.filters) {
            const index = targetFilters.findIndex(filter => filter.key === filterKey);
            if (index > -1) {
                this.$set(targetFilters[index], 'active', value);
            }
        },
        defaultTimeRangePayload() {
            return {
                time_range: {
                    start: moment().startOf('month').format('YYYY-MM-DD'),
                    end: moment().endOf('month').format('YYYY-MM-DD'),
                    value: 'thisMonth'
                }
            };
        },
        hydrateFromUrl() {
            const query = new URLSearchParams(window.location.search);

            this.$store.dispatch('clearFilterObject');

            const payload = {};
            query.forEach((rawValue, key) => {
                payload[key] = this.parseQueryValue(rawValue);
            });

            const hasDateState = payload.time_range || payload.within || payload.month || payload.month_number || payload.year;
            if (!hasDateState) {
                Object.assign(payload, this.defaultTimeRangePayload());
            }

            if (Object.keys(payload).length) {
                this.$store.dispatch('updateFilterObject', payload);
            } else {
                this.setDefaultFilter();
            }

            this.selectedUserId = payload.user || JSON.parse(this.firstUser).id;

            this.applyFilterActiveState('departments', payload.departments || undefined);
            this.applyFilterActiveState('working_shifts', payload.working_shifts || undefined);
            this.applyFilterActiveState('designations', payload.designations || undefined);
            this.applyFilterActiveState('employment_statuses', payload.employment_statuses || undefined);
            this.applyFilterActiveState('time_range', payload.time_range || undefined);

            this.applyFilterActiveState('user', this.selectedUserId, this.tableOptions.filters);
            this.setActiveUserToDropdownFilter(this.selectedUserId);
            this.setActiveUserToAvatarFilter(this.selectedUserId);

            this.getSelectableUsers(payload.departments || '');
            this.filterStateVersion += 1;
        },
        syncUrlFromFilterState() {
            if (this.historySyncMode === 'none') {
                this.historySyncMode = 'replace';
                return;
            }

            const query = objectToQueryString(this.filterQuery || {});
            const url = new URL(window.location.href);

            url.search = '';

            if (query) {
                const params = new URLSearchParams(query);
                params.forEach((value, key) => {
                    url.searchParams.set(key, value);
                });
            }

            const defaultUserId = JSON.parse(this.firstUser).id;
            if (this.selectedUserId && Number(this.selectedUserId) !== Number(defaultUserId)) {
                url.searchParams.set('user', this.selectedUserId);
            }

            if (this.historySyncMode === 'push') {
                window.history.pushState({}, '', url);
            } else {
                window.history.replaceState({}, '', url);
            }

            this.historySyncMode = 'replace';
        },
        handleBrowserNavigation() {
            this.historySyncMode = 'none';
            this.hydrateFromUrl();
        },
        setDefaultFilter() {
            this.$store.dispatch('updateFilterObject', this.defaultTimeRangePayload())
        },
        getAttendanceSummary(userId = false) {
            this.preloader = true;
            let employeeId = userId || this.selectedUserId || this.user.id
            if (employeeId) {
                axiosGet(`${this.apiUrl.ATTENDANCES}/${employeeId}/summaries?${this.queryString}`).then(response => {
                    this.summaries = response.data;
                    const {regular, early, late, on_leave} = this.summaries;
                    this.dataSet = [regular, early, late, on_leave];
                }).finally(() => {
                    this.preloader = false;
                });
            }
        },
        changeUser(type) {
            this.isChanging = true;
            axiosGet(`${this.apiUrl.APP_SELECTABLE}/${this.employee.id || this.user.id}/next-user/${type}`)
                .then(response => {
                    this.nextUser = response.data;
                    this.selectedUserId = this.nextUser.id;
                    this.historySyncMode = 'push';
                    this.$store.dispatch('updateFilterObject', {
                        user: this.nextUser.id
                    });
                    // this.setActiveUserToAvatarFilter(this.nextUser.id);
                    this.setActiveUserToDropdownFilter(this.nextUser.id);
                })
        },
        setUserId(filter) {
            this.selectedUserId = filter.user || this.selectedUserId || this.user.id;
            this.historySyncMode = 'push';
            this.$store.dispatch('updateFilterObject', filter);
            // this.setActiveUserToAvatarFilter(filter.user)
            this.setActiveUserToDropdownFilter(this.selectedUserId);
            // Filter users by departments if department is selected
            this.getSelectableUsers(filter.departments);
        },
        setTableDataNumber(numberOfData){
            this.tableData = numberOfData;
        },
        viewConfirmationModal(allEmployee = false) {
            if (allEmployee) {
                this.exportAllEmployee = true;
                this.modalSubtitle = this.$t('all_employees_attendance_export_title');
                this.modalMessage = this.$t('all_employees_attendance_export_message');
            } else {
                this.exportAllEmployee = false;
                this.modalSubtitle = this.$t('attendance_export_title');
                this.modalMessage = this.$t('attendance_export_message');
            }
            if (this.tableData < 1) {
                this.noDataFoundModal = true;
            } else {
                this.exportConfirmationModal = true;
            }
        },
        exportFilteredAttendance() {
            let url = urlGenerator(`${this.apiUrl.EXPORT}/${this.employee.id || this.user.id}/attendance?${this.queryString}&timeZone=${localTimeZone}&locale=${window.appLanguage}`);
            if (this.exportAllEmployee) {
                url = urlGenerator(`${this.apiUrl.EXPORT}/attendance/all?${this.queryString}&timeZone=${localTimeZone}&locale=${window.appLanguage}`);
            }
            url += `&export_type=${this.exportType}`;
            this.triggerExportDownload(url);
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.exportConfirmationModal = false;
        },
        viewExportAllModal() {
            this.exportAllModal = true;
        },
        closeExportAllModal() {
            this.exportAllModal = false;
        },
        handleConfirmExport(data) {
            let url = urlGenerator(`${this.apiUrl.EXPORT}/attendance/all?${this.queryString}&timeZone=${localTimeZone}&locale=${window.appLanguage}`);
            url += `&department_id=${data.selectedDepartment || ''}`;
            url += `&user_ids=${data.selectedUsers.length ? data.selectedUsers.join(',') : ''}`;
            url += `&export_type=${data.exportType}`;
            url += `&start_date=${encodeURIComponent(data.startDate || '')}`;
            url += `&end_date=${encodeURIComponent(data.endDate || '')}`;
            this.triggerExportDownload(url);
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.exportConfirmationModal = false;
        },
        triggerExportDownload(url) {
            const checkUrl = `${url}${url.includes('?') ? '&' : '?'}check_only=1`;
            axiosGet(checkUrl).then(() => {
                window.location = url;
            }).catch(({response}) => {
                this.$toastr.e('', response?.data?.message || this.$t('no_attendance_data_found'));
            });
        },
        handleImportComplete() {
            this.isImportModalActive = false;
            this.$hub.$emit('reload-summary');
        }
    },
    computed: {
        specificId() {
            if (this.specific) {
                return JSON.parse(this.firstUser)?.id
            }
            return '';
        },
        isPreviousNull() {
            return collection(this.getAllUsers).first().id === this.employee.id
        },
        getAllUsers() {
            return this.tableOptions.filters.find(data => data.key === 'user').option
        },
        isNextNull() {
            return collection(this.getAllUsers).last().id === this.employee.id
        },
        user() {
            if (this.$can('view_attendance_summary') && !this.$can('view_all_attendance')) {
                return window.user;
            }
            return this.isChanging ? this.nextUser : JSON.parse(this.firstUser);
        },
        queryString() {
            return this.$store.getters.getFilterUrls;
        },
        employee() {
            return this.summaries.employee
        },
        profileUrl() {
            return urlGenerator(`${this.apiUrl.EMPLOYEES_PROFILE}/${this.employee.id}/profile`)
        },
        specificEmployee() {
            return (this.$can('view_attendance_summary') && !this.$can('view_all_attendance')) ||
                this.specific
        },
        filteredTableOptions() {
            return {
                ...this.tableOptions,
                filters: [
                    ...this.options.filters.filter(filter => filter.key === 'departments'),
                    ...this.tableOptions.filters.filter(filter => filter.type !== 'avatar-filter'),
                ]
            }
        }
    },
    mounted() {
        window.addEventListener('popstate', this.handleBrowserNavigation);
        this.$hub.$on('reload-summary', () => {
            this.getAttendanceSummary(this.selectedUserId || this.employee?.id);
        })
        this.$hub.$on('employeeDetailsActionHappened', (value) => {
            this.getAttendanceSummary(this.selectedUserId || this.employee?.id);
        });
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.handleBrowserNavigation);
    },
    watch: {
        queryString: {
            handler: function (queryString) {
                if (!queryString) {
                    return;
                }
                this.exportable = this.filterQuery.within !== 'thisYear';
                this.syncUrlFromFilterState();
                this.getAttendanceSummary(this.selectedUserId || this.employee?.id);
            },
            immediate: true
        },
    },
}
</script>
